export default "__VITE_ASSET__4fffc0bd__"